module.exports = __webpack_public_path__ + "img/img4.49623e5c.png";